export default __webpack_public_path__ + "static/media/Calzado.7de52699.png";